// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"SocialResponsibilityBlogSection_cardContainer__B5_40","cardBox":"SocialResponsibilityBlogSection_cardBox__Oz7qg"};